__turbopack_context__.v({
  "shimmer": "RZDwzq_shimmer",
  "skeleton": "RZDwzq_skeleton",
  "text-bar-sweep": "RZDwzq_text-bar-sweep",
});
